import React, { useState } from 'react';
import { BaseConfig } from '../BaseConfig';
import GeneralButton from '../helpers/GeneralButton';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';

const BVMAttemptChooseHandUI = (props: UIProperties<BVMAttemptChooseHandUIConfig>) => {
	const [isOneHanded, setIsOneHanded] = useState(true);
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%'
		}}>
			<div style={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				width: '800px',
				height: '460px'
			}}>
				<img style={{
					width: '100%',
					height: '70px'
				}} src="./assets/images/SBAR/header_modal_1.png"/>
				<div style={{
					position: 'absolute',
					top: '01px',
					left: '3px',
					width: '100%',
					height: '65px',
				}}>
					<p style={{
						margin: '0px',
						fontSize: '25pt',
						textAlign: 'center',
						position: 'relative',
						top: '13px'
					}} className="title-font" tabIndex={0} id='bvm-choose-hand-header'>BVM Ventilation Attempt</p>
				</div>
				<div style={{
					width: '100%',
					height: '390px',
					position: 'absolute',
					top: '70px',
					left: '0'
				}}>
					<img style={{
						width: '100%',
						height: '100%'
					}} src="./assets/images/SBAR/window_modal_1_edited.png"/>

					<CustomBVMAttemptButton 
						showYellowThingyOnTheSide={isOneHanded}
						width= '180px'
						text='One Hand'
						isDisabled={false}
						position= {{
							type: 'absolute', 
							top: '97px',
							left: '111px'
						}}
						onClicked={() => {
							setIsOneHanded(true);
						}}/>
					<CustomBVMAttemptButton 
						showYellowThingyOnTheSide={!isOneHanded}
						width= '180px'
						text='Two Hands'
						isDisabled={false}
						position= {{
							type: 'absolute', 
							top: '97px',
							left: '480px'
						}}
						onClicked={() => {
							setIsOneHanded(false);
						}}/>
					<GeneralButtonWithText parameters= {{
						text: 'Next',
						top: '354px',
						ariaLbl: 'next',
						id: 'bvm-choose-hand-next',
						left: '330px',
						width: '140px',
						isDisabled: false,
						srcIdle: "./assets/images/main-menu/button_menu_exit.png",
						srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
						srcDisabled: null,
						customImgStyle: {
						},
						customButtonStyle : {
						},
						customTextStyle: {
							fontSize: '12pt'
						},
						onClicked: () => {
							props.parameters.onNextClicked(isOneHanded);
						}
					}}/>
					
				</div>
				
			</div>
		</div>
	);

};

const CustomBVMAttemptButton = (props: CustomBVMAttemptChooseHandButtonConfig) => {
	return (
		<div style={{
			position: props.position.type ? props.position.type : 'relative',
			top: props.position.top,
			left: props.position.left,
			width: props.width,
			pointerEvents: 'none'
		}}>
			<div style={{
				position: 'relative'
			}}>
				<GeneralButtonWithText parameters= {{
					text: '',
					top: '0px',
					left: '0px',
					ariaLbl: props.text,
					isDisabled: props.isDisabled,
					width: props.width,
					srcIdle: './assets/images/general/buttons/button_side_large-1.png',
					srcHighlight: null,
					srcDisabled: './assets/images/general/buttons/button_side_large-1.png',
					customMainStyle: {
						// position: 'relative',
						// width: props.isFlipped ? '99px' : '129px',
						// transform: props.isFlipped ? 'scaleX(-1)' : 'scaleX(1)'
					},
					onClicked: () => {
						if(props.onClicked) {
							props.onClicked();
						}
					}
				}}/>
				
				<div style={{
					position: 'relative',
					height: '128px',
					pointerEvents: 'none',
					width: '166px',
					left: '0px',
					top: '2px'
				}}>
					<div style={{
						position: 'relative',
						top: '50%',
						transform: 'translate(0, -50%)'
					}}>
						<p className='title-font' style={{
							textAlign: 'center',
							margin: '0',
							fontSize: '16pt',
							fontWeight: 'normal'
						}}>{props.text}</p>
					</div>
					
				</div>

				{props.showYellowThingyOnTheSide ? (
					<img style={{
						position: 'absolute',
						top: 0,
						right: '-23px',
						width: '36px',
						pointerEvents: 'none'
					}} src="./assets/images/general/buttons/button_side_pointer.png" />
				) : (null)}
			</div>
		</div>
	);
};

interface CustomBVMAttemptChooseHandButtonConfig {
	text: string;
	width: string;
	position: CustomBVMAttemptChooseHandButtonPosition;
	showYellowThingyOnTheSide?: boolean;
	isDisabled?: boolean;
	onClicked?: () => void;
}

interface CustomBVMAttemptChooseHandButtonPosition {
	type?: any;
	left: string;
	top: string;
}

export interface BVMAttemptChooseHandUIConfig extends BaseConfig{
	onNextClicked: (isOneHanded: boolean) => void;
}

export default BVMAttemptChooseHandUI;